import xhr from '../utils/fetch';

const collectpayment = async (data: any) => {
  return await xhr({
    url: '/b/paynow',
    method: 'POST',
    body: data
  })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
};

export const PayNowAPi = {
  collectpayment
};
